import "./index.css";
import { ButtonComp as v } from "./ButtonComp.js";
import { IconComp as A } from "./IconComp.js";
import { DialogComp as T } from "./DialogComp.js";
import { OverlayComp as I } from "./OverlayComp.js";
import { BaseModalComp as M } from "./BaseModalComp.js";
import { OverflowComp as x } from "./OverflowComp.js";
import { SelectGroupComp as N } from "./SelectGroupComp.js";
import { SelectGroupOptionComp as $ } from "./SelectGroupOptionComp.js";
import { RouterLinkComp as B } from "./RouterLinkComp.js";
import { RouterButtonComp as w } from "./RouterButtonComp.js";
import { CollapsibleCardComp as E } from "./CollapsibleCardComp.js";
import { CollapsibleComp as V } from "./CollapsibleComp.js";
import { SearchFilterComp as k } from "./SearchFilterComp.js";
import { RadioGroupComp as P } from "./RadioGroupComp.js";
import { CountrySelectComp as L } from "./CountrySelectComp.js";
import { CountryFlagSelectComp as O } from "./CountryFlagSelectComp.js";
import { LanguageSelectComp as R } from "./LanguageSelectComp.js";
import { MaskComp as z } from "./MaskComp.js";
import { ObjectSelectComp as G } from "./ObjectSelectComp.js";
import { PhoneComp as W } from "./PhoneComp.js";
import { TextInputSelectComp as F } from "./TextInputSelectComp.js";
import { TableComp as K } from "./TableComp.js";
import { WaitingComp as _ } from "./WaitingComp.js";
import { ContainedIconComp as j } from "./ContainedIconComp.js";
import { NameBadgeComp as H } from "./NameBadgeComp.js";
import { VirtualTableComp as q } from "./VirtualTableComp.js";
import { PercentProgressBarComp as D } from "./PercentProgressBarComp.js";
import { LazyImageComp as Q } from "./LazyImageComp.js";
import { CheckboxComp as U } from "./CheckboxComp.js";
import { InputComp as J } from "./InputComp.js";
import { SelectItemComp as X } from "./SelectItemComp.js";
import { V as Y, W as g } from "./WrapperComp.204dcf4e.js";
import { SwitchComp as Z } from "./SwitchComp.js";
import { QuantityComp as ee } from "./QuantityComp.js";
import { SearchComp as oe } from "./SearchComp.js";
import { defineComponent as te, resolveComponent as re, openBlock as i, createElementBlock as p, normalizeStyle as n, createVNode as ae, createSlots as le, withCtx as l, createElementVNode as se, normalizeClass as d, withKeys as me, toDisplayString as ie, createCommentVNode as pe, renderSlot as u, normalizeProps as f, guardReactiveProps as h } from "vue";
import { i as ne } from "./isNil.6f60d6a4.js";
import { u as de } from "./uniqueId.f48d78c2.js";
import { _ as ue } from "./_plugin-vue_export-helper.dad06003.js";
import { RadioComp as fe } from "./RadioComp.js";
import { EmptyResultsComp as he } from "./EmptyResultsComp.js";
import { SpinnerComp as ce } from "./SpinnerComp.js";
import { bannerComp as ge } from "./BannerComp.js";
import { NavbarComp as Ce } from "./NavbarComp.js";
import { AppLinkComp as be } from "./AppLinkComp.js";
import { ProgressBarComp as ye } from "./ProgressBarComp.js";
import { ToastComp as Se } from "./ToastComp.js";
import { NumberInputComp as ve } from "./NumberInputComp.js";
import { TextInputComp as Ae } from "./TextInputComp.js";
import { TextAreaComp as Te } from "./TextAreaComp.js";
import { SnackbarComp as Ie } from "./SnackbarComp.js";
import { SelectComp as Me } from "./SelectComp.js";
import { TopBreadcrumbsComp as xe } from "./TopBreadcrumbsComp.js";
import { TopNavBarComp as Ne } from "./TopNavBarComp.js";
import { LeftNavBarComp as $e } from "./LeftNavBarComp.js";
import { SegmentedTabsComp as Be } from "./SegmentedTabsComp.js";
const we = te({
  mixins: [Y],
  components: {
    WrapperComp: g
  },
  events: {
    "update:modelValue": {
      type: String,
      Note: "Emits input type back"
    },
    "update:errorMessages": {
      type: Array,
      Note: "Updates the Error message array"
    }
  },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => de("textAreaComp")
    },
    modelValue: {
      type: String,
      default: "",
      Note: "This is the actual v-model of the component"
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => [],
      Note: 'This is the secondary v-model:errorMessages="" of the component'
    },
    infoMessages: {
      type: Array,
      default: () => []
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    },
    maxLength: Number,
    placeholder: String,
    label: String,
    labelSpecialText: String,
    labelIcon: String,
    supportingText: String,
    height: String,
    maxHeight: String,
    width: String,
    disabled: Boolean,
    fieldSizing: String,
    /**
     * Default look is the compact label variant, set true to use label above variant
     */
    labelAbove: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      focused: !1
    };
  },
  mounted() {
    if (this.autofocus) {
      const e = document.getElementById(this.id);
      e && e.focus();
    }
  },
  computed: {
    textAreaClasses() {
      return {
        textArea__textArea: !0,
        "textArea__textArea--error": this.isErrorState,
        "textArea__textArea--disabled": this.disabled,
        "textArea__textArea--maxLength": this.maxLength
      };
    },
    styleOverides() {
      return {
        height: this.height,
        width: this.width
      };
    },
    textAreaStyles() {
      return {
        "max-height": this.maxHeight,
        "field-sizing": this.fieldSizing
      };
    },
    filled() {
      return !ne(this.modelValue) && this.modelValue !== "";
    },
    hasPlaceholder() {
      var e;
      return !!((e = this.placeholder) != null && e.trim());
    },
    characterCount() {
      var e;
      return `${((e = this.modelValue) == null ? void 0 : e.length) ?? 0} / ${this.maxLength}`;
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
    handleEnterKey(e) {
      e.key === "Enter" && this.$emit("enterKeyPressed");
    },
    handleFocus() {
      this.$emit("focus"), this.focused = !0;
    },
    async handleBlur() {
      await this.sleep(150), this.$refs.textArea !== document.activeElement && (this.$emit("blur"), this.focused = !1, this.validateInputOnBlur());
    },
    async sleep(e) {
      return new Promise((o) => setTimeout(o, e));
    },
    hasSlot(e) {
      return !!this.$slots[e];
    },
    validate() {
      const e = this.runValidationMethod(this.modelValue);
      return this.$emit("update:errorMessages", e), e.filter((o) => o.id === this.id);
    }
  }
});
const Ee = ["id", "value", "maxlength", "placeholder", "rows", "disabled"];
function Ve(e, o, r, m, a, We) {
  const S = re("wrapper-comp");
  return i(), p("div", {
    class: "textArea",
    style: n(e.styleOverides)
  }, [
    ae(S, {
      id: e.id,
      label: e.label,
      labelIcon: e.labelIcon,
      labelSpecialText: e.labelSpecialText,
      supportingText: e.supportingText,
      validationRules: e.validationRules,
      errorMessages: e.errorMessages,
      disableMessages: e.disableMessages,
      infoMessages: e.infoMessages,
      labelAbove: e.labelAbove,
      disabled: e.disabled,
      hasPlaceholder: e.hasPlaceholder,
      isFocused: e.focused,
      filled: e.filled
    }, le({
      default: l(() => [
        se("textarea", {
          style: n(e.textAreaStyles),
          id: e.id,
          ref: "textArea",
          class: d(e.textAreaClasses),
          value: e.modelValue,
          maxlength: e.maxLength,
          placeholder: e.placeholder,
          rows: e.rows,
          onFocus: o[0] || (o[0] = (t) => e.handleFocus()),
          onBlur: o[1] || (o[1] = (t) => e.handleBlur()),
          onInput: o[2] || (o[2] = (...t) => e.handleInput && e.handleInput(...t)),
          onKeyup: o[3] || (o[3] = me((...t) => e.handleEnterKey && e.handleEnterKey(...t), ["enter"])),
          disabled: e.disabled
        }, null, 46, Ee),
        e.maxLength ? (i(), p("p", {
          key: 0,
          class: d(["textArea__characterCount", { "textArea__characterCount--labelAbove": e.labelAbove }])
        }, ie(e.characterCount), 3)) : pe("", !0)
      ]),
      _: 2
    }, [
      e.hasSlot("messages") ? {
        name: "messages",
        fn: l((t) => [
          u(e.$slots, "messages", f(h(t)), void 0, !0)
        ]),
        key: "0"
      } : void 0,
      e.hasSlot("labelIcon") ? {
        name: "labelIcon",
        fn: l((t) => [
          u(e.$slots, "labelIcon", f(h(t)), void 0, !0)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["id", "label", "labelIcon", "labelSpecialText", "supportingText", "validationRules", "errorMessages", "disableMessages", "infoMessages", "labelAbove", "disabled", "hasPlaceholder", "isFocused", "filled"])
  ], 4);
}
const ke = /* @__PURE__ */ ue(we, [["render", Ve], ["__scopeId", "data-v-29b8c7c4"]]), s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppLinkComp: be,
  BannerComp: ge,
  BaseModalComp: M,
  ButtonComp: v,
  CheckboxComp: U,
  CollapsibleCardComp: E,
  CollapsibleComp: V,
  ContainedIconComp: j,
  CountryFlagSelectComp: O,
  CountrySelectComp: L,
  DialogComp: T,
  EmptyResultsComp: he,
  IconComp: A,
  InputComp: J,
  LanguageSelectComp: R,
  LazyImageComp: Q,
  LeftNavBarComp: $e,
  MaskComp: z,
  NameBadgeComp: H,
  NavbarComp: Ce,
  NewTextAreaComp: ke,
  NumberInputComp: ve,
  ObjectSelectComp: G,
  OverflowComp: x,
  OverlayComp: I,
  PercentProgressBarComp: D,
  PhoneComp: W,
  ProgressBarComp: ye,
  QuantityComp: ee,
  RadioComp: fe,
  RadioGroupComp: P,
  RouterButtonComp: w,
  RouterLinkComp: B,
  SearchComp: oe,
  SearchFilterComp: k,
  SegmentedTabsComp: Be,
  SelectComp: Me,
  SelectGroupComp: N,
  SelectGroupOptionComp: $,
  SelectItemComp: X,
  SnackbarComp: Ie,
  SpinnerComp: ce,
  SwitchComp: Z,
  TableComp: K,
  TextAreaComp: Te,
  TextInputComp: Ae,
  TextInputSelectComp: F,
  ToastComp: Se,
  TopBreadcrumbsComp: xe,
  TopNavBarComp: Ne,
  VirtualTableComp: q,
  WaitingComp: _,
  WrapperComp: g
}, Symbol.toStringTag, { value: "Module" })), Pe = `:root{--pl-theme: "protolabs-2023";--pl-blue: #0068ad;--pl-dark-blue: #00558c;--pl-brand-blue: #0068ad;--pl-brand-blue-5: #0068ad;--pl-brand-blue-15: #0068ad;--pl-brand-blue-25: #0068ad;--pl-brand-blue-hover: #00558c;--pl-legacy-orange: #0068ad;--pl-legacy-orange-2: #0068ad;--pl-legacy-orange-20: #0068ad;--pl-legacy-orange-hover: #00558c;--pl-legacy-red: #0068ad;--pl-legacy-red-15: #0068ad}
`, Le = "protolabs-2023", C = "protolabs-theme", Oe = "--pl-theme", c = {
  "protolabs-2023": Pe
}, b = (e, o = !1) => {
  try {
    const r = e && c[e] ? e : Le;
    if (!o && Re())
      return;
    const m = document.getElementsByTagName("head")[0], a = document.createElement("style");
    a.id = C, a.innerHTML = c[r], m.appendChild(a);
  } catch {
  }
}, Re = () => {
  var o;
  const e = document.querySelector(`#${C}`);
  return e ? ((o = e.innerHTML) == null ? void 0 : o.indexOf(Oe)) > -1 : !1;
};
var y = /* @__PURE__ */ ((e) => (e.Blue = "Blue", e.SecondaryBlue = "SecondaryBlue", e.SecondaryWhite = "SecondaryWhite", e.Gray = "Gray", e.AnchorStyle = "AnchorStyle", e.NavWhite = "NavWhite", e.NavGray = "NavGray", e.SelectWhite = "SelectWhite", e.SelectGray = "SelectGray", e))(y || {});
const ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ButtonStyles: y
}, Symbol.toStringTag, { value: "Module" })), Ge = (e, o) => {
  b((o == null ? void 0 : o.theme) ?? "protolabs-2023");
  for (const r in s)
    e.component(r, s[r]);
}, Ho = {
  components: s,
  install: Ge,
  useTheme: b,
  ...ze
};
export {
  be as AppLinkComp,
  ge as BannerComp,
  M as BaseModalComp,
  v as ButtonComp,
  y as ButtonStyles,
  U as CheckboxComp,
  E as CollapsibleCardComp,
  V as CollapsibleComp,
  j as ContainedIconComp,
  O as CountryFlagSelectComp,
  L as CountrySelectComp,
  T as DialogComp,
  he as EmptyResultsComp,
  A as IconComp,
  J as InputComp,
  R as LanguageSelectComp,
  Q as LazyImageComp,
  $e as LeftNavBarComp,
  z as MaskComp,
  H as NameBadgeComp,
  Ce as NavbarComp,
  ke as NewTextAreaComp,
  ve as NumberInputComp,
  G as ObjectSelectComp,
  x as OverflowComp,
  I as OverlayComp,
  D as PercentProgressBarComp,
  W as PhoneComp,
  ye as ProgressBarComp,
  ee as QuantityComp,
  fe as RadioComp,
  P as RadioGroupComp,
  w as RouterButtonComp,
  B as RouterLinkComp,
  oe as SearchComp,
  k as SearchFilterComp,
  Be as SegmentedTabsComp,
  Me as SelectComp,
  N as SelectGroupComp,
  $ as SelectGroupOptionComp,
  X as SelectItemComp,
  Ie as SnackbarComp,
  ce as SpinnerComp,
  Z as SwitchComp,
  K as TableComp,
  Te as TextAreaComp,
  Ae as TextInputComp,
  F as TextInputSelectComp,
  Se as ToastComp,
  xe as TopBreadcrumbsComp,
  Ne as TopNavBarComp,
  q as VirtualTableComp,
  _ as WaitingComp,
  g as WrapperComp,
  Ho as default,
  b as useTheme
};
//# sourceMappingURL=index.js.map
